import React from "react";
import { Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BasicTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Tab
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          A basic example with tab panels.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <Box sx={{ borderBottom: 1, borderColor: \"divider\" }}>\n" +
              "                <Tabs\n" +
              "                  value={value}\n" +
              "                  onChange={handleChange}\n" +
              "                  aria-label=\"basic tabs example\"\n" +
              "                >\n" +
              "                  <Tab label=\"Item One\" {...a11yProps(0)} />\n" +
              "                  <Tab label=\"Item Two\" {...a11yProps(1)} />\n" +
              "                  <Tab label=\"Item Three\" {...a11yProps(2)} />\n" +
              "                </Tabs>\n" +
              "              </Box>\n" +
              "              <CustomTabPanel value={value} index={0}>\n" +
              "                Item One\n" +
              "              </CustomTabPanel>\n" +
              "              <CustomTabPanel value={value} index={1}>\n" +
              "                Item Two\n" +
              "              </CustomTabPanel>\n" +
              "              <CustomTabPanel value={value} index={2}>\n" +
              "                Item Three\n" +
              "              </CustomTabPanel>"}>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Item One" {...a11yProps(0)} />
                  <Tab label="Item Two" {...a11yProps(1)} />
                  <Tab label="Item Three" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                Item One
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                Item Two
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                Item Three
              </CustomTabPanel>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicTabs;
